import * as types from "./actionTypes";

const initialState = {
  data: []
};

const banner = (state = initialState, action) => {
  switch (action.type) {
    case types.BANNER_GET:
      return {
        ...state,
        data: action.data.response
      };

    default:
      return state;
  }
};

export default banner;



// WEBPACK FOOTER //
// ./src/modules/banner/reducer.js